import { isProxy } from 'vue'
import { handleAuthLogin } from '@/utils/router'
import { useUserStore } from '@/stores/user'
import { postUserInfo, postUserOnLineWeb } from '@/api/app'

export const init = async (router) => {
  let route = null
  const proxy = isProxy(router)
  const user = useUserStore()
  const pathname = location.pathname
  const token = GetParams(window.location.href, 'token')
  const header = GetParams(window.location.href, 'header')
  if (token) {
    user.setToken(token)
  }
  if (header === 'hidden') {
    user.setHeaderFlag(false)
  }
  if (!proxy) {
    const routes = router.getRoutes()
    route = routes.find(r => r.path === pathname)
  } else {
    route = router
  }
  try {
    let line
    if (window.qt) {
      // 获取用户信息
      const data = await postUserInfo()
      user.setUserInfo({ ...data.data })
    } else {
      line = await postUserOnLineWeb()
      if (line?.data) {
        // 获取用户信息
        const data = await postUserInfo()
        user.setUserInfo({ ...data.data })
      } else {
        handleAuthLogin(route)
      }
    }
  } catch (error) {
    console.log(error)
  }
}
function GetParams (fullUrl, key) {
  if (!fullUrl) {
    fullUrl = window.location.href
  }
  let paramsArray = fullUrl.split('?')[1]
  if (paramsArray) {
    paramsArray = paramsArray.split('&')
  }
  const paramsObj = {}
  paramsArray?.forEach(function (element) {
    const keyVal = element.split('=')
    paramsObj[keyVal[0]] = keyVal[1]
  })
  return key ? paramsObj[key] : paramsObj
}
